// extracted by mini-css-extract-plugin
export default {"testpage":"TestPage_testpage__Z+7hd","transcriptionContainer":"TestPage_transcriptionContainer__8+tn9","button":"TestPage_button__8wHx-"};